import Vue from 'vue';
import Vuex from 'vuex';
import live from './modules/live';
import brandList from './modules/brandList';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    windowHeight: 0, // 窗口高度
    siteName: localStorage.getItem('siteName') || '', // 网点名称
    appName: localStorage.getItem('appName') || '', // 小程序名称
    guiderName: localStorage.getItem('guiderName') || '', // 导购名称
    authMenuCodeList: localStorage.getItem('authMenuCodeList') ? localStorage.getItem('authMenuCodeList').split(',') : [], // 菜单权限
    empCode: localStorage.getItem('empCode') || '', // 雇员编号
    dialogHeight: localStorage.getItem('dialogHeight') || '', //
  },
  mutations: {
    // 储存窗口高度
    onSaveWindowHeight(state, payload) {
      state.windowHeight = payload;
    },
    // 修改网点名称
    onModifySiteName(state, payload) {
      localStorage.setItem('siteName', payload);
      state.siteName = payload;
    },
    // 修改小程序名称
    onModifyAppName(state, payload) {
      localStorage.setItem('appName', payload);
      state.appName = payload;
    },
    // 修改导购名称
    onModifyGuiderName(state, payload) {
      localStorage.setItem('guiderName', payload);
      state.guiderName = payload;
    },
    // 修改导菜单权限
    onModifyAuthMenuCodeList(state, payload) {
      localStorage.setItem('authMenuCodeList', payload.join());
      state.authMenuCodeList = payload;
    },
    // 修改雇员编号
    onModifyEmpCode(state, payload) {
      localStorage.setItem('empCode', payload);
      state.empCode = payload;
    },
    // 满屏弹窗高度
    onDialogHeightModify(state, payload) {
      localStorage.setItem('dialogHeight', payload);
      state.dialogHeight = payload;
    },
  },
  actions: {},
  modules: {
    live,
    brandList,
  },
});
